
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/scheduler/standalone-agenda-view-premium",
      function () {
        return require("private-next-pages/x/api/scheduler/standalone-agenda-view-premium.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/scheduler/standalone-agenda-view-premium"])
      });
    }
  